// Zakres dni Statystyk: przyciski liczone od chwili kliknięcia, własny zakres z kalendarza (całe dni czasu telefonu).

export type Rodzaj = "24h" | "7d" | "30d" | "rok" | "wlasny";
export type Przycisk = Exclude<Rodzaj, "wlasny">;

export interface Zakres {
  rodzaj: Rodzaj;
  od: number; // unix s
  do: number;
}

export const DOBA_S = 86400;
export const ROK_S = 365 * DOBA_S; // najdłuższy zakres jednego wykresu (brama samplesMaxRange); historia sięga dalej

export const PRZYCISKI: [Przycisk, string, number][] = [
  ["24h", "24 h", DOBA_S], ["7d", "7 dni", 7 * DOBA_S], ["30d", "30 dni", 30 * DOBA_S], ["rok", "Rok", ROK_S],
];

export function zakresDo(rodzaj: Przycisk, teraz = Date.now() / 1000): Zakres {
  const s = PRZYCISKI.find((p) => p[0] === rodzaj)?.[2] ?? DOBA_S;
  return { rodzaj, od: teraz - s, do: teraz };
}

/** „2026-10-19” → północ czasu telefonu (unix s). */
export function polnoc(d: string): number {
  const [r, m, dz] = d.split("-").map(Number);
  return new Date(r ?? 0, (m ?? 1) - 1, dz ?? 1).getTime() / 1000;
}

/** unix s → „2026-10-19” (pole daty). */
export function dzien(s: number): string {
  const d = new Date(s * 1000);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}
